<ng-container *transloco="let t">
  <td class="w-5 pl-3" (click)="selectStrategy()">
    <ICheckbox [value]="!!isSelected()" />
  </td>
  <td iTableTd class="max-w-0 min-w-84 truncate">
    <app-strategy-link
      [strategyId]="strategy().strategyId"
      [strategyGroupName]="strategy().isStrategyGroup ? strategy().strategyName : undefined"
      [strategyGroupState]="strategy().isStrategyGroup || strategy().isTacosStrategy ? strategy().state : undefined"
      target="_self"
    />
  </td>
  <td iTableTd class="truncate">
    <div class="min-h-8">
      @if (!strategy().hasSubStrategies) {
        <app-algo-target-renderer-v2
          [strategy]="strategy().strategy"
          [organizationId]="organizationId()"
          [currency]="currency()"
          [locale]="locale()"
          [isReadonly]="isReadonly()"
          [addLabel]="true"
        />
      }
    </div>
  </td>
  @for (column of gridColumns(); track column) {
    <td iTableTd class="truncate">
      @switch (column) {
        @case ("asins") {
          <span class="text-gray-500">{{ strategy().asins.length }}</span>
        }
        @case ("info") {
          @if (!strategy().isStrategyGroup) {
            <app-strategy-grid-info [strategy]="strategy().strategy" />
          }
        }
        @case ("tactics") {
          <app-strategy-grid-tactic
            [strategy]="strategy().strategy"
            [strategyGroup]="strategy().strategyGroup"
            [segmentIndex]="segmentIndex()"
          />
        }
        @case ("brand") {
          @if (strategy().creatives; as creatives) {
            <span class="text-gray-500">{{ creatives | strategyGridBrand: accountMarketplace() : brands() }}</span>
          }
        }
        @case ("adline") {
          @if (strategy().creatives; as creatives) {
            <app-strategy-grid-ad-line [strategyCreatives]="creatives" />
          }
        }
        @case ("targetings") {
          <app-strategy-grid-targetings [strategy]="strategy().strategy" [segmentIndex]="segmentIndex()" />
        }
        @case ("funnel") {
          <app-strategy-grid-dsp-funnel [strategy]="strategy().strategy" />
        }
        @case ("strategies") {
          <div class="flex gap-2 text-xs font-semibold">
            @for (campaignType of strategy().campaignTypes; track campaignType) {
              <app-campaign-type-badge [campaignType]="campaignType" />
            }
          </div>
        }
        @case ("creativeType") {
          <app-strategy-grid-creative-type [strategy]="strategy().strategy" />
        }
      }
    </td>
  }
  <td>
    <div class="flex justify-end gap-2 pr-2">
      <div class="flex w-full justify-end">
        <button
          iButton
          [iDropdownMenuTrigger]="actionMenu"
          [loading]="isUpdatingStrategy()"
          variant="ghost"
          size="sm"
          class="opacity-0 group-hover:opacity-100"
          placement="bottom-end"
          [testId]="'strategy-actions-' + strategy().strategyName"
          (click)="$event.stopPropagation()"
        >
          @if (!isUpdatingStrategy()) {
            <IIcon name="ellipsis" />
          }
        </button>
      </div>
      <ng-template #actionMenu>
        <IDropdownMenu>
          @let isStrategyGroupWithMultipleStrategies =
            strategy().isStrategyGroup && (strategy().strategyGroup?.strategies?.length ?? 0) > 1;
          @let statusChangeDisabled =
            isChangingStrategyStatus() || isStrategyGroupWithMultipleStrategies || isReadonly();
          <button
            iDropdownMenuItem
            size="sm"
            [iTooltip]="
              isStrategyGroupWithMultipleStrategies ? t('strategy-grid.strategy_group_cant_be_enabled_or_disabled') : ''
            "
            iTooltipPlacement="left-center"
            [disabled]="statusChangeDisabled"
            (click)="!statusChangeDisabled && changeStrategyStatus()"
          >
            <IIcon class="mr-1" [name]="strategy().state === 'PAUSED' ? 'playCircle' : 'pauseCircle'" />
            {{ strategy().state === "PAUSED" ? t("common.activate") : t("common.deactivate") }}
          </button>
          @if (!strategy().strategy.defaultStrategy) {
            <IDropdownMenuSeparator />
            <button
              iDropdownMenuItem
              variant="danger"
              size="sm"
              [attr.data-testid]="`delete-strat-${strategy().strategyName}`"
              [disabled]="isDeletingStrategy() || isReadonly()"
              (click)="deleteStrategy()"
            >
              <IIcon name="trash" class="mr-1" />
              {{ t("common.delete") }}
            </button>
          }
        </IDropdownMenu></ng-template
      >
    </div>
  </td>
</ng-container>
